import React from 'react';
import { withRouter } from 'react-router';
import moment from 'moment';

import {
	Col,
	BPanel,
	Progress,
	Button,
	ListGroupItem,
	ListGroup,
	FormGroup,
	ControlLabel,
	FormControl,
	Alert,
	AlertLink,
	Icon
} from '@sketchpixy/rubix';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

import { AlertsViewer } from '../alerts/AlertsViewer';
import { PlanningDay } from './PlanningDay';
import { PlanningDateIntervalSelector } from './PlanningDateIntervalSelector';

import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Reservations } from '../../collections/reservations/reservations';

import { SmsManager } from '../../external_api/smsManager';
import { Reactive } from '../common/Reactive.mixin.js';

@withRouter
@Reactive({
	subscriptions: ["flights-type", "montgolfieres", "users", "places"],
})
export default class PlanningPage extends React.Component {

    constructor(props) {
        super(props);

		this.state = {};
		this.state.place = "all";
		this.state.startDate = new Date;
		this.state.endDate = moment().add(1, 'week').toDate();

		if (this.props.location.query.date) {
			this.state.startDate = new Date(this.props.location.query.date);
			this.state.endDate = moment(this.props.location.query.date).add(1, 'week').toDate();
		}

		Tracker.nonreactive(() => {
			this.state.subscriptions = {
				available: Meteor.subscribe("availableAndScheduledBetween", this.state.startDate, this.state.endDate, () => this.forceUpdate()),
			}
		});

		this.changeInterval = _.debounce(this.changeInterval, 300);
    }

    componentDidMount() {

    	if(this.place)
    		this.place.setAttribute('nochilddrag', true);

		const $container = jQuery('#body .container-fluid').css({
			overflow: 'scroll',
		})

		let width = $container.width();

		console.log('width', width);

		if(width > 950) {
			$container.kinetic ?
				$container.kinetic('attach')
				: $container.kinetic({
					slowdown: 0.2,
					triggerHardware: true,
					filterTarget: function(target, e){
						if (!/down|start/.test(e.type)) {
							return !(/area|a|input|select/i.test(target.tagName));
						}
					}
				});

		}
		jQuery('#body').css({
			paddingTop: 0,
			paddingBottom: 0
		});
    }

    componentWillUnmount() {
        jQuery('#body .container-fluid').css({
			overflow: 'auto',
			paddingTop: 0
		}).kinetic('detach');
		jQuery('#body').css({
			paddingTop: 25,
			paddingBottom: 25
		});

		this.state.subscriptions.available.stop();
    }

	renderDays() {
		let days = [];
		for (let i = 0; i < 7; i++) {
			days.push(
				<Col sm={4} key={i}>
					<PlanningDay date={moment(this.state.startDate).add(i, 'days').toDate()} place={this.state.place !== "all" ? this.state.place : null} />
				</Col>
			);
		}

		return days;
	}

	changeInterval({startDate, endDate}) {
		this.state.subscriptions.available.stop();
		this.setState({
			subscriptions: { available: Meteor.subscribe("availableAndScheduledBetween", startDate, endDate, () => { this.forceUpdate(); }) },
			startDate,
			endDate
		});
		this.props.router.push('/planning?date=' + startDate);
	}

	handleChangePlace(e) {
		const place = e.target.value;

		this.state.subscriptions.available.stop();
		this.setState({
			subscriptions: { available: Meteor.subscribe("availableAndScheduledBetween", this.state.startDate, this.state.endDate, () => this.forceUpdate()) },
			place
		});
	}

    render() {

    	if(!this.props.isReady) {
    		return (
    			<p>Chargement...</p>
    		);
    	}

        return (
            <div className="planning-container">
                <Col sm={4}>
					<PlanningDateIntervalSelector startDate={this.state.startDate} endDate={this.state.endDate} onChange={::this.changeInterval}></PlanningDateIntervalSelector>

                    <br/>
                    <Col sm={12}>

                        <BPanel header="Planning">
							<FormGroup controlId="place">
                                <Col sm={3}><ControlLabel>Lieux</ControlLabel></Col>
								<Col sm={9}>
									<FormControl componentClass="select" placeholder="Lieux" onChange={::this.handleChangePlace} inputRef={ref => this.place = ref}>
										<option value="all">Tous</option>
										<option value="anjou">Anjou</option>
										<option value="nantes">Nantes</option>
									</FormControl>
								</Col>
                            </FormGroup>
                        </BPanel>
                    </Col>
                    <Col sm={12}>
                        <AlertsViewer></AlertsViewer>
                    </Col>
                    <Col sm={12}>
                        <BPanel header="Légende">
                          <ListGroup>
                            <ListGroupItem bsStyle="info">Anjou</ListGroupItem>
                            <ListGroupItem bsStyle="warning">Nantes</ListGroupItem>
                            <ListGroupItem disabled>Programmé</ListGroupItem>
                          </ListGroup>
                        </BPanel>
                    </Col>
                </Col>
				{ this.renderDays() }
            </div>
        );
      }
    }



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningPage.js
 **/